var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMobileMenuTrigger = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 7h18M1 1h18M1 13h18"
})));
export default SvgMobileMenuTrigger;